export const getNameExtension = (fileName) => {
    const multiPartExtensions = ['.tar.gz', '.tar.bz2'];

    const multiPartExtension = multiPartExtensions.find((extension) =>
        fileName.endsWith(extension)
    );

    let name, extension;

    if (multiPartExtension) {
        const lastDotIndex = fileName.lastIndexOf(multiPartExtension);

        name = fileName.substring(0, lastDotIndex);
        extension = fileName.substring(lastDotIndex + 1);
    } else {
        const lastDotIndex = fileName.lastIndexOf('.');
        name = fileName.substring(0, lastDotIndex);
        extension = fileName.substring(lastDotIndex + 1);
    }

    return { name, extension };
};
